module.exports = require("deep-equal");